import { jsx as _jsx } from "react/jsx-runtime";
import { RenderWithBuilder } from "@faire/web--source/builder/BuilderComponents/RenderWithBuilder";
import { ConductorSurface } from "@faire/web-api--source/indigofair/data/ConductorSurface";
import React from "react";
import { useConductorComponent } from "@faire/retailer-visitor-shared/features/Conductor/useConductorComponent";
import { SDUISiteBannerRenderer } from "../../SDUI/ComponentRenderers/SiteBanner/SDUISiteBannerRenderer";
import { SDUIRenderer } from "../../SDUI/SDUIRenderer/SDUIRenderer";
import { SDUIColumnSectionRenderer } from "../../SDUI/SectionRenderers/ColumnSection/SDUIColumnSectionRenderer";
import { SDUIRotatingSectionRenderer } from "../../SDUI/SectionRenderers/RotatingSection/SDUIRotatingSectionRenderer";
var bannerComponentRenderers = {
    site_banner_component: {
        active: SDUISiteBannerRenderer
    }
};
var bannerSectionRenderers = {
    column_section: SDUIColumnSectionRenderer,
    rotating_section: SDUIRotatingSectionRenderer
};
export var ConductorBanner = function(param) {
    var overrideViewLayout = param.overrideViewLayout;
    var _viewLayout_content;
    var _useConductorComponent = useConductorComponent({
        surface: ConductorSurface.SITE_WIDE_TOP_BANNER
    }), conductorBuilderModelName = _useConductorComponent.conductorBuilderModelName, conductorSduiViewLayout = _useConductorComponent.conductorSduiViewLayout;
    var viewLayout = overrideViewLayout !== null && overrideViewLayout !== void 0 ? overrideViewLayout : conductorSduiViewLayout;
    if (conductorBuilderModelName) {
        return /*#__PURE__*/ _jsx(RenderWithBuilder, {
            modelName: conductorBuilderModelName
        });
    }
    if (!(viewLayout === null || viewLayout === void 0 ? void 0 : (_viewLayout_content = viewLayout.content) === null || _viewLayout_content === void 0 ? void 0 : _viewLayout_content.length)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SDUIRenderer, {
        viewLayout: viewLayout,
        componentRenderers: bannerComponentRenderers,
        sectionRenderers: bannerSectionRenderers,
        UPLTprops: {
            shouldRenderBelowTheFold: false
        }
    });
};
